import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";

import {
	Toolbar as RhombusToolbar
	, Button
} from "rhombus-react";

import { assignLibrary } from "reducers/QA";
import { confirmRemoveAssignee } from "reducers/Confirm";

import SelectCount from 'widgets/toolbars/SelectCount';
import { SEARCH_DEBOUNCE } from "utils/constants";

import "./Toolbar.css";

export default function Toolbar({ searchTerm, handleSearch, isLoading }) {
	let dispatch = useDispatch();
	let {
			currentSelection,
			qaItems,
			userName,
			userId,
		} = useSelector((state) => {
			return {
				currentSelection: state.selected.qa,
				qaItems: state.qa.items,
				userName:state.you.userName,
				userId:state.you.id,
			};
		})
		, isSomethingSelected = (currentSelection.length > 0)
		, searchProps = {
			isDisabled: isLoading || isSomethingSelected,
		}
		, $actions = null
		, clearList = useMemo(() => {
			return qaItems.filter((v) => {
				return currentSelection.includes(v.id);
			});
		}, [currentSelection, qaItems]);

	function assignToMe(e){
		e.preventDefault();
		dispatch(assignLibrary({ id:userId, userName }, currentSelection));
	}

	function clearAssignment(e){
		e.preventDefault();
		dispatch(confirmRemoveAssignee(assignLibrary, { libraries:clearList }));
	}

	if(isSomethingSelected){
		$actions = [
			<Button
				key="assign-me"
				icon="far fa-user-check"
				className="cypress-qa-bulk-assign-me"
				theme="blue"
				style="block"
				onClick={assignToMe}>{`Assign to Me (${currentSelection.length})`}</Button>
			, <Button
				key="unassign"
				icon="far fa-user-slash"
				className="cypress-qa-bulk-clear-me"
				theme="blue"
				style="block"
				onClick={clearAssignment}>{`Clear Assignee (${currentSelection.length})`}</Button>
		];
	}

	return (
		<RhombusToolbar
			search
			searchProps={searchProps}
			searchDebounce={SEARCH_DEBOUNCE}
			onSearch={handleSearch}
			searchValue={searchTerm}
			className="qa-toolbar"
		>
			<div className="button-side">
				<SelectCount type="qa" label="Libraries" />
				{$actions}
				<NavLink to="reports/">
					<Button icon="fas fa-chart-bar" className="report-link" theme="blue" style="block">Reports</Button>
				</NavLink>
			</div>
			<div className="right-button-side" />
		</RhombusToolbar>
	);
}

Toolbar.displayName = "QAToolbar";
Toolbar.propTypes = {
	handleSearch:PropTypes.func.isRequired,
};
